/* eslint-disable global-require */

export default [
  {
    id: 0,
    title: "slide 1",
    img: require("../images/Home/header/home-slide-3.jpg.webp"),
    imgColor: "dark",
  },
  {
    id: 1,
    title: "slide 2",
    img: require("../images/Home/header/home-slide-2.jpg.webp"),
    imgColor: "light",
  },
  {
    id: 2,
    title: "slide 3",
    img: require("../images/Home/header/home-slide-1.jpg.webp"),
    imgColor: "light",
  },
];
